import { Constants } from '@leverege/molten-core';
import ImagineConditionFilterModelConfigurer from "./ImagineConditionFilterModelConfigurer.js";
import ComparatorPlugins from "./comparator/PluginSetup.js";
import FilterConditionFilterConverter from "./FilterConditionFilterConverter.js";
import LogicalConditionFilterConverter from "./LogicalConditionFilterConverter.js";
import AttributeConditionFilterConverter from "./AttributeConditionFilterConverter.js";
import SuggestorPlugins from "./suggestor/PluginSetup.js";
import ImagineConditionFilterModelBlueprintProcessor from "./ImagineConditionFilterModelBlueprintProcessor.js";
import ImagineConditionFilterOptionsBlueprintProcessor from "./ImagineConditionFilterOptionsBlueprintProcessor.js";
export default {
  install(molten) {
    ComparatorPlugins.install(molten);
    molten.addPlugin('ImagineConditionFilterConverter', FilterConditionFilterConverter);
    molten.addPlugin('ImagineConditionFilterConverter', LogicalConditionFilterConverter);
    molten.addPlugin('ImagineConditionFilterConverter', AttributeConditionFilterConverter);
    molten.addPlugin('ConditionFilterModelConfigurer', ImagineConditionFilterModelConfigurer);
    molten.addPlugin(Constants.BLUEPRINTS_PROCESSOR, ImagineConditionFilterModelBlueprintProcessor);
    molten.addPlugin(Constants.BLUEPRINTS_PROCESSOR, ImagineConditionFilterOptionsBlueprintProcessor);
    SuggestorPlugins.install(molten);
  }
};